import React from 'react';

export default ({ color, width, height }) => (
  <svg version="1.1" id="Layer_1" width={width} height={height} viewBox="0 0 92 74">
    <g id="Page-1">
      <g id="Computer1">
        <path
          id="Shape"
          style={{ fill: color }}
          d="M85,0h-69c-1.8,0-3.5,0.7-4.8,2c-1.3,1.3-2,3-2,4.8v16.5H1c-0.1,0-0.3,0-0.4,0.1
			c-0.1,0-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.2-0.2,0.3C0,24.1,0,24.2,0,24.3v47.4c0,0.1,0,0.3,0.1,0.4s0.1,0.2,0.2,0.3
			c0.1,0.1,0.2,0.2,0.3,0.2c0.1,0,0.2,0.1,0.4,0.1h25.2c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7V58.4h15.6v8.5H40
			c-1.4,0-2.8,0.6-3.8,1.6c-1,1-1.6,2.4-1.6,3.8c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3h29.6c0.3,0,0.5-0.1,0.7-0.3
			c0.2-0.2,0.3-0.4,0.3-0.7c0-1.4-0.6-2.8-1.6-3.8c-1-1-2.4-1.6-3.8-1.6h-2.7v-8.5H85c1.8,0,3.5-0.7,4.8-2c1.3-1.3,2-3,2-4.8V6.8
			c0-1.8-0.7-3.5-2-4.8C88.5,0.7,86.8,0,85,0z M25.2,70.7H2V25.3h23.2V70.7z M26.2,23.3H15.6V6.8h69.7v45.3H27.1V24.3
			c0-0.1,0-0.3-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3c-0.1-0.1-0.2-0.2-0.3-0.2C26.4,23.4,26.3,23.4,26.2,23.3L26.2,23.3z M60.9,68.8
			c0.7,0,1.4,0.2,2,0.6c0.6,0.4,1,1,1.2,1.7H36.8c0.2-0.7,0.6-1.3,1.2-1.7c0.6-0.4,1.3-0.6,2-0.6H60.9z M44.7,66.9v-8.5h11.5v8.5
			H44.7z M89.8,51.7c0,1.3-0.5,2.5-1.4,3.4c-0.9,0.9-2.1,1.4-3.4,1.4H27.1v-2.5h59.1c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7
			V5.8c0-0.3-0.1-0.5-0.3-0.7c-0.2-0.2-0.4-0.3-0.7-0.3H14.6c-0.3,0-0.5,0.1-0.7,0.3c-0.2,0.2-0.3,0.4-0.3,0.7v17.6H11V6.8
			c0-1.3,0.5-2.5,1.4-3.4s2.2-1.4,3.4-1.4H85c0.6,0,1.3,0.1,1.9,0.4s1.1,0.6,1.6,1.1c0.5,0.5,0.8,1,1.1,1.6c0.2,0.6,0.4,1.2,0.4,1.9
			L89.8,51.7z"
        />
        <path
          id="Path"
          style={{ fill: color }}
          d="M22.7,31v4.5c0,0.1,0,0.3-0.1,0.4c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.2-0.3,0.2
			c-0.1,0-0.2,0.1-0.4,0.1H5.5c-0.1,0-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2S4.6,36,4.6,35.9c0-0.1-0.1-0.2-0.1-0.4V31
			c0-0.3,0.1-0.5,0.3-0.7C5,30.1,5.2,30,5.5,30h16.2c0.3,0,0.5,0.1,0.7,0.3C22.6,30.5,22.7,30.7,22.7,31z"
        />
        <path
          id="Path_1_"
          style={{ fill: color }}
          d="M22.7,40v4.5c0,0.3-0.1,0.5-0.3,0.7c-0.2,0.2-0.4,0.3-0.7,0.3H5.5c-0.3,0-0.5-0.1-0.7-0.3
			c-0.2-0.2-0.3-0.4-0.3-0.7V40c0-0.1,0-0.3,0.1-0.4c0-0.1,0.1-0.2,0.2-0.3s0.2-0.2,0.3-0.2C5.2,39,5.3,39,5.5,39h16.2
			c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.3C22.6,39.7,22.7,39.8,22.7,40z"
        />
        <path
          id="Shape_1_"
          style={{ fill: color }}
          d="M13.6,50c-0.8,0-1.6,0.3-2.2,0.8c-0.6,0.5-1,1.3-1.1,2.1c-0.1,0.8,0.1,1.6,0.5,2.3
			s1.1,1.2,1.9,1.4v8.6c0,0.3,0.1,0.5,0.3,0.7c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7v-8.6
			c0.8-0.2,1.5-0.7,1.9-1.4c0.4-0.7,0.6-1.5,0.5-2.3c-0.1-0.8-0.5-1.6-1.2-2.1C15.2,50.3,14.4,50,13.6,50z M13.6,54.8
			c-0.3,0-0.6-0.1-0.8-0.2c-0.2-0.2-0.4-0.4-0.5-0.6c-0.1-0.3-0.1-0.6-0.1-0.8c0.1-0.3,0.2-0.5,0.4-0.7c0.2-0.2,0.5-0.3,0.7-0.4
			c0.3-0.1,0.6,0,0.8,0.1c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.3,0.5,0.3,0.8c0,0.2,0,0.4-0.1,0.6s-0.2,0.3-0.3,0.5
			c-0.1,0.1-0.3,0.2-0.5,0.3C14,54.8,13.8,54.8,13.6,54.8z"
        />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/resources/react-svg/Computer1.js